/*
 * @Author: mina.min
 * @Date: 2025-01-20 10:00:00
 * @LastEditors: mina.min
 * @LastEditTime: 2025-01-20 10:00:00
 * @FilePath: /OTAManagementSystem/src/pages/FirmwareManagement/index.tsx
 * @Description: 固件管理主组件
 */
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import FirmwareList from './FirmwareList'
import OTAUpgrade from './OTAUpgrade'
import './index.scss'

const FirmwareManagement: React.FC = () => {
  const location = useLocation()
  const [currentView, setCurrentView] = useState('firmware-list')

  // 根据当前路径设置显示的内容
  useEffect(() => {
    const path = location.pathname
    if (path.includes('/firmware/ota')) {
      setCurrentView('ota-upgrade')
    } else {
      setCurrentView('firmware-list')
    }
  }, [location.pathname])

  const renderContent = () => {
    switch (currentView) {
      case 'firmware-list':
        return <FirmwareList />
      case 'ota-upgrade':
        return <OTAUpgrade />
      default:
        return <FirmwareList />
    }
  }

  return <div className='firmware-management-wrapper'>{renderContent()}</div>
}

export default FirmwareManagement
